import React, { useEffect } from "react";
import { connect } from "react-redux";

import { _fetchFollowers, _followUnfollow } from "../../store/follow/actions";
import {Link} from "react-router-dom";
import "./Followers.scss";

const Followers = (props) => {
  useEffect(async () => {
    // if(props.followers.followers.len)
    await props._fetchFollowers();
  }, []);
  const followUnfollow = async(id) => {
    await props._followUnfollow(id);
    props._fetchFollowers();
  }
  return (
    <div className="Followers">
      <h1 className=" font-weight-bold text-black-50 mb-5 pb-3 border-bottom w-100 text-left">
        Followers
      </h1>
      {
        !props.followers.isLoading && props.followers.isFollowerLoaded ? 
        (
          props.followers.followers.map((follower)=> (
            <div className="list p-4 d-flex justify-content-between align-items-center flex-column flex-md-row m-2 m-md-4 border-circle shadow">
            <div className="left d-flex justify-content-start align-items-center flex-column flex-md-row ">
              <img
                src="/images/bg/2b5be3f5db32c1dbfd5702da8af2f247.webp"
                alt=""
                className="img"
              />
              <div className="">
                <h4>{follower?.followed_by?.name}</h4>
              </div>
            </div>
            <h3 className="text-muted">{follower?.followed_by?.music_genre}</h3>
            <div>
            <button className="btn outline mx-2" onClick={()=>{
              followUnfollow(follower?.followed_by?._id)
            }}>Follow</button>
            <Link to={`/view-profile/${follower?.followed_by?._id}`}>
            <button className="btn outline mx-2">View Profile</button>
            </Link>
            </div>
          </div>
          ))
        ) : 
        "Loading..."
      }
    </div>
  );
};

const mapStateToProps = (state) => ({
  followers: state.follow,
});

export default connect(mapStateToProps, {
  _fetchFollowers,
  _followUnfollow
})(Followers);
